const transformDateToDe = (date: string): string => {
  return date.split("-").reverse().join(".");
};

export default transformDateToDe;
